import React from 'react'
function Record404() {
    return (
        <div className="shadow shadow-intensity-md rounded-3 mt-4 mb-4 py-4 text-center">
            <span className="text-center fs-14rem">No Record Available</span>
        </div>
    )
}
export default Record404;
